import React, { useMemo, useState } from "react";
// import { Form } from "react-bootstrap";
import { useControl, useControlReducer } from "../../../controlContext";
import { useSource } from "../../../sourceContext";
import { genId } from "../../../../../shared/utils";
// import { groupTypes } from "../utils/consts";
// import { ButtonControls } from "./buttonControls";
import { MultiSelectDisplay } from "./multiselectDisplay";
// import { langTypeMap } from "../../../../../shared/Data/langTypeMap";


export function MultiSelect({ name, sourceAddress, parent, label, displaySettings, idx }) {
  const [controls] = useControl()
  const controlReducer = useControlReducer()
  const source = useSource()
  const [displayKeys, setDisplayKeys] = useState(['content'])
  const [showEditItem, setShowEditItem] = useState(false)
  const [viewMode, setVM] = useState(false) //false:relative, true: all
  const value = useMemo(()=>controls[name], [controls, name])
  const parentContent = useMemo(()=> parent && controls[parent], [controls, parent])
  const options = useMemo(() => {
    return source[name] && source[name].reduce((acc, itm, idx) => {
      if (shouldAddOption(itm, parentContent, parent, viewMode)) {
        acc.push(
          <option key={idx} onDoubleClick={() => setShowEditItem(true)} value={itm._id}>{
            itm.getDisplayText()
          }</option>)
      }
      return acc
    }, [])
  }, [source, name, parentContent, parent, viewMode])

  function setViewMode(toggle) {
    controlReducer(getChangedAction(name, '', idx))
    setVM(toggle)
  }

  function changed(evt) {
    controlReducer(getChangedAction(name, evt.target.value, idx))
  }

  // console.log('rendering multi, controls', parent, getParentContent(), controls, source[name])
  return (
    <MultiSelectDisplay
      {...{
        displaySettings,
        label,
        changed,
        value,
        options,
        buttonControlsProps: {
          name, displayKeys, setDisplayKeys, viewMode, setViewMode
        },
        name,
        showEditItem, setShowEditItem,
        idx
      }}
    />
  )

}

function shouldAddOption(itm, parentContent, parent, viewMode) {
  return viewMode || !parent || (parent && parentContent && itm[`_${parent}`] === parentContent)
}

function getChangedAction(name, value, idx) {
  return { type: 'changed', _id: genId(), name, value, idx }
}